<template>
  <div class="w-100">
    <div v-for="(partner, index) in partners" :key="index" class="partner-entry">
      <hr v-if="index > 0" class="mt-4" />

      <form-input
        class="col-12 form-input mb-3"
        label="Nome completo"
        v-model="partner.name"
        :id="`partners[${index}].name`"
        :name="`partners[${index}].name`"
      />

      <form-input
        class="col-12 form-input mb-3"
        label="E-mail"
        v-model="partner.email"
        type="email"
        :id="`partners[${index}].email`"
        :name="`partners[${index}].email`"
      />

      <div class="row g-2">
        <form-phone
          class="col-12 col-md-6 form-input mb-3"
          label="DDD + Telefone"
          v-model="partner.phone"
          :id="`partners[${index}].phone`"
          :name="`partners[${index}].phone`"
        />

        <form-input
          class="col-12 col-md-6 form-input mb-3"
          label="Participação (%)"
          v-model="partner.percentage"
          type="number"
          min="0"
          max="100"
          :id="`partners[${index}].percentage`"
          :name="`partners[${index}].percentage`"
        />
      </div>

      <form-switch
        className="col-12 form-input"
        description="O sócio assina pela empresa?"
        v-model="partner.canSignContracts"
        :id="`partners[${index}].canSignContracts`"
        :name="`partners[${index}].canSignContracts`"
      />

      <form-money
        v-if="partner.canSignContracts"
        className="col-12 form-input mb-3"
        v-model="partner.avgMonthlyIncome"
        label="Renda média mensal"
        :id="`partners[${index}].avgMonthlyIncome`"
        :name="`partners[${index}].avgMonthlyIncome`"
        :config="moneyFormat('R$ ', '.', ',', 2)"
      />

      <p v-if="error" class="text-danger text-center mt-2">
        {{ error }}
      </p>

      <form-button
        v-if="index > 0"
        class="col-12 form-input mt-0"
        title="Remover sócio"
        buttonColor="secondary remove"
        @click="removePartner(index)"
      />
    </div>

    <div class="col-12 d-flex justify-content-center mb-1">
      <img :src="lineImg" height="24" />
    </div>

    <form-button
      class="col-12 form-input"
      buttonColor="add mt-0"
      title="Adicionar sócio"
      @clicked="addPartner"
    />
  </div>
</template>

<script>
import { formInput, formButton, formPhone, formMoney, formSwitch } from 'tb-design_system-web'
import { computed } from 'vue'

import { moneyFormat } from '@/composables/utils/moneyConfig'

export default {
  name: 'FormBusinessPartners',
  components: {
    formInput,
    formPhone,
    formSwitch,
    formButton,
    formMoney
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    error: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const partners = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    })
    const lineImg = new URL('@/assets/img/svg/line.svg', import.meta.url).href

    const addPartner = () => {
      partners.value = [
        ...partners.value,
        {
          name: '',
          phone: '',
          email: '',
          percentage: '',
          canSignContracts: false,
          avgMonthlyIncome: ''
        }
      ]
    }

    const removePartner = (index) => {
      if (partners.value.length > 1) {
        partners.value = partners.value.filter((_, i) => i !== index)
      }
    }

    return {
      partners,
      addPartner,
      removePartner,
      lineImg,
      moneyFormat
    }
  }
}
</script>

<style scoped lang="scss">
.add {
  background-color: #d7d7d7 !important;
  border-color: #d7d7d7 !important;
  color: #000 !important;
}
.remove {
  margin-top: 5px !important;
}
.form-check {
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  background-color: #f2f2f2;
  border-radius: 6px;
  padding: 10px 10px 10px 34px;

  .form-check-label {
    cursor: pointer;
  }
}
</style>
